module.exports = __webpack_public_path__ + "img/student-header-shape.21fcacb3.png";